<template>
	<div id="theTabs">
		<div class="spacer"></div>
		<div class="tabWrapper flex">
			<div
				class="tab"
				@click="switchPage('SmartLock')"
				:class="{ active: setActive('SmartLock') }">
				<font-awesome-icon
					class="iconBtn minus"
					:icon="['fal', 'lock-open-alt']"
				/>
				<span class="iconText">入口解錠</span>
			</div>
			<div class="tab"
				@click="switchPage('Cashier')"
				:class="{ active: setActive('Cashier') }">
				<font-awesome-icon
					class="iconBtn minus"
					:icon="['fal', 'cash-register']"
				/>
				<span class="iconText">セルフレジ</span>
			</div>
			<div
				class="tab"
				@click="switchPage('StoreLive')"
				:class="{ active: setActive('StoreLive') }">
				<font-awesome-icon
					class="iconBtn minus"
					:icon="['fal', 'cctv']"
				/>
				<span class="iconText">ライブカメラ</span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'theTabs',
	methods: {
		setActive (target) {
			const { $route } = this
			const { name } = $route
			return name === target
		},
		switchPage (target) {
			const { name } = this.$route
			if (target === name) return
			this.$router.push({ name: target })
		}
	}
}
</script>

<style lang="stylus" scoped>
@import "~@/themes/styles/mixins.styl"

#theTabs
	.spacer
		height 60px
	.tabWrapper
		background #fff
		border-top 1px solid main-light-dark
		position fixed
		bottom 0
		left 0
		width 100%
		height 60px
		.tab
			flex 1
			text-align center
			cursor pointer
			padding-top 8px
			&.active
				color main-light-dark
			.iconText
				font-size 12px
				display block
</style>
